// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2IPME","rootSuccess":"CompleteLink_rootSuccess__qtY2H","rootFailure":"CompleteLink_rootFailure__2_XFo","isDisabled":"CompleteLink_isDisabled__2sR_Q"};